import Select from "react-select";
import { useContext } from "react";
import authService from "../../../../services/login/auth.service";
import CuentaCompromisoSocio from "../../../generico/CuentaCompromisoSocio";
import { useEffect } from "react";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import Popup from "react-popup";
import { WizardContext } from "../../../generico/CustomStepWizard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export const PagoSepelioPaso1 = (props) => {

    const sepelioContext = useContext(WizardContext);
    const { state, setState, getPagareList } = sepelioContext;

    const notifiPopup = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });

    const ctaOrigenValue = (ctaFullData, item) => {
        let usuario = authService.getCurrentUser();
        ctaFullData = { ...ctaFullData, denominacion: usuario.nombreCompleto };
        setState({ ...state, ctaFullData, ctaOrigenSele: item });
    };

    const montoValue = (_monto) => {
        setState({ ...state, monto: _monto });
    };

    const disableContinuar = () => {
        return (state.ctaFullData === null || state.infoPagare === null);
    }

    const pagareOptions = state.pagareList.map(pagare => ({
        label: `${pagare.idSolicitud} - ${pagare.nombreEmpresa}`,
        value: pagare.idSolicitud,
    }));

    const onChangeSelect = (item) => {
        let infoPagare = state.pagareList.find(pagare => pagare.idSolicitud === item.value);
        setState({ ...state, infoPagare, itemSelected: item });
    }

    const checkContinuar = () => {

        let saldo = parseInt(state.ctaFullData.disponible);
        let montoAPagar = state.infoPagare.montoAPagar;

        if (montoAPagar > saldo) {
            Popup.queue(notifiPopup("Info", "El monto a pagar es mayor a su saldo actual."));
            return false;
        }

        props.nextStep();

    }

    useEffect(() => {
        if (state.desdeMenu) getPagareList();
    }, [])


    return (
        state.pagareList.length === 0 && state.infoPagare === null ?
            <div className="text-center">
                No existen pagarés pendientes
            </div>
            :
            <div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-7 col-md-10">
                                <CuentaCompromisoSocio
                                    renderMonto="false"
                                    selectorValue={ctaOrigenValue}
                                    montoValue={montoValue}
                                    operacion="DEBITO"
                                    tipoCuenta="AHORRO_VISTA"
                                    items={state.cuentasOrigen}
                                    itemSelected={state.ctaOrigenSele}
                                    titleImporte="Ingrese el Importe a Pagar"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {
                    state.pagareList.length > 1 &&
                    <div className="row justify-content-center mb-3">
                        <div className="col-md-7">
                            <label className="input-label-bold">Seleccionar Pagaré *</label>
                            <Select
                                required="required"
                                placeholder="-- Seleccione --"
                                value={state.itemSelected}
                                onChange={onChangeSelect}
                                options={pagareOptions}
                                isClearable
                                noOptionsMessage={() => "SIN DATOS"}
                            />
                        </div>
                    </div>
                }

                {
                    state.infoPagare &&
                    <div className="row justify-content-center mb-3">
                        <div className="col-lg-7 col-md-10">
                            <label className="input-label-bold">Detalles de Pagaré</label>
                            <p className="m-0"><span style={{ fontWeight: 400 }}>Nro de Solicitud:</span> {state.infoPagare.idSolicitud}</p>
                            <p className="m-0">Empresa: {state.infoPagare.nombreEmpresa}</p>
                            {
                                state.infoPagare.nombreSubsidiado &&
                                <p className="m-0">Subsidiado/a: {state.infoPagare.nombreSubsidiado}</p>
                            }
                        </div>
                    </div>
                }

                <div className="row justify-content-md-center">
                    <div className="col-lg-7 col-md-10">
                        <label className="input-label-bold">Importe a Pagar</label>
                        <p>{formatoSeparadorMilesValue(state.infoPagare ? state.infoPagare.montoAPagar : 0)}</p>
                    </div>
                </div>

                <hr />

                <div className="row">
                    <div className="col-lg-10 col-md-8">
                            <label
                                className="input-label-bold-obligatorio">
                                (*) Campos Obligatorios
                                <br />
                            </label>
                    
                    </div>
                    <div className="col-lg-2 col-md-4">
                            <button
                                disabled={disableContinuar()}
                                className="btn btn-cu-primary"
                                onClick={checkContinuar}
                            >
                               Continuar <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                    </div>
                </div>
            </div>
    );
}